export const CREDENTIALS_STATUS = {
	pending: 'pending',
	in_verification: 'in_verification',
	verified: 'verified',
	expired: 'expired',
	signed: 'signed',
	declined: 'decline',
	rejected: 'rejected',
	returned: 'returned',
}

export const CREDENTIAL_STATUS_MAPPING = {
	[CREDENTIALS_STATUS.verified]: {
		label: 'Verified',
		textColor: '#3BB700',
		backgroundColor: '#3BB7001A',
	},
	[CREDENTIALS_STATUS.in_verification]: {
		label: 'Under Review',
		textColor: '#2C6EEE',
		backgroundColor: '#2C6EEE1A',
	},
	[CREDENTIALS_STATUS.pending]: {
		label: 'Pending submission',
		textColor: '#FF9B04',
		backgroundColor: '#FF9B041A',
	},
	[CREDENTIALS_STATUS.expired]: {
		label: 'Expired',
		textColor: '#FF2727',
		backgroundColor: '#FF27271A',
	},
	[CREDENTIALS_STATUS.signed]: {
		label: 'Signed',
		textColor: '#3BB700',
		backgroundColor: '#3BB7001A',
	},
	[CREDENTIALS_STATUS.declined]: {
		label: 'Declined',
		textColor: '#FF2727',
		backgroundColor: '#FF27271A',
	},
	[CREDENTIALS_STATUS.rejected]: {
		label: 'Rejected',
		textColor: '#FF2727',
		backgroundColor: '#FF27271A',
	},
	[CREDENTIALS_STATUS.returned]: {
		label: 'Returned',
		textColor: '#FF9B04',
		backgroundColor: '#FF9B041A',
	},
}

export const DOCUMENT_ACTIONS = {
	upload: 'upload',
	upload_and_download: 'upload_and_download',
	download: 'download',
	webform: 'webform',
	no_action: 'no_action',
}

export const submitText = {
	[DOCUMENT_ACTIONS.upload]: 'INSTRUCTIONS_TO_SUBMIT',
	[DOCUMENT_ACTIONS.download]: 'VIEW_DETAIL',
	[DOCUMENT_ACTIONS.upload_and_download]: 'INSTRUCTIONS_TO_SUBMIT',
	[DOCUMENT_ACTIONS.webform]: 'SIGN_AND_SUBMIT',
	[DOCUMENT_ACTIONS.no_action]: '',
}

export const submitAgainText = {
	[DOCUMENT_ACTIONS.upload]: 'RESUBMIT',
	[DOCUMENT_ACTIONS.download]: 'VIEW_DETAIL',
	[DOCUMENT_ACTIONS.upload_and_download]: 'RESUBMIT',
	[DOCUMENT_ACTIONS.webform]: 'SIGN_AND_SUBMIT_AGAIN',
	[DOCUMENT_ACTIONS.no_action]: '',
}

export const fakeUploadFilesImg = [
	{
		id: '8f5fb9c7-57f7-4c88-ba51-cc9b3f571016',
		fileUrl:
			'https://mlg-nonprod-stg-ghr-backend-qa.s3.us-west-2.amazonaws.com/18f9nprv7cmt3fp1rmc2yrtqlbsp?response-content-disposition=inline%3B%20filename%3D%22Pic1.png%22%3B%20filename%2A%3DUTF-8%27%27Pic1.png&response-content-type=image%2Fpng&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAZVSMF5PD6JKNPJ4O%2F20240627%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240627T095004Z&X-Amz-Expires=300&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIBm5BUf1UmPBipNrVj17j6NpIjV7QdexLV6NU8vahq2%2BAiAA05PQMZoIxWjo5CrqLY67kgo3e%2Fij4qlhZnEZ0uyM2SqlBQjr%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAMaDDY2NDgwNTk2MDY0NyIMKV%2FbTx7YtIUVLgpuKvkEjTYSKxOjWBBOjNtK%2F5BcjqnfjEhg2wiRRFpaJzvyyN%2F%2FjFd054HzZHTVhyt7FWGng867uR5R0P68d43RJdzWp5VUzfeCAvAIQxExqpjWo1330H13MCG1sjPIuNgTCBQVgrvhbl1o60o1cq%2FqiVrGtEFv3%2BBz3EgFdi93YG4EeuyviQFerHlwGZ5lfwWCyRGo%2FftTOSiAhN67BXfFd9fAo%2FDwTcoyuM3BDOTgVF3rA1VWI21%2BgJsz408xCEEkDJELfyqJZLntpuZPhFI%2Fh2qQNu8wMsTRW4hmoIoxrb3C9OsOQVG3ddwo4bZjL%2F8tlWhn3JgpTvsSHDwuTwIqESdtNI4IhRXXTorYItMTpyMRmOgjtWb2butRb909XmVIyckfM5liWwoG38c86aSXzzi4pmILUueTuVGK273rwrBQmRXLz9uvVvPv4IYvJxx2WC5nmqTXlUaM39H41owXyItNKTFnPMmTH8FF3CtgMoQxoey8dsO%2B34x1PpfKrrE8YNwwDO8NrOqNVvNAWqM2Eg%2BL37CPPEqyQmslWP7vSBZBgnLr5m%2BpPxiZdlpQUGc%2BWTS2fa8kVNjJNdahJuDsZCs5efOWW2BeVBoMi%2FaCblzeh3gZoRzU9%2B2MtYeWyGa2SB4UGaTRAdzE7ddEw2lf9otil%2FmRNC4woUPwvn7%2BkNCzpb3fMt3v4O7VefcUf2zKri8dsaoowNBqRm1xQAyewj%2Ba%2BL9xI3poR3oQkGZ1rHsCXOVuhMHIsS9oK7b7%2B1P1C2bzf2Adri2FehZ1EVCMsDruX4SqtVfiUe0XIFCgC%2Bn2oLfnFJBageh0YEH%2BxGegnzKCx51a%2FmFSXORSMPvq9LMGOpsB7I%2Frcr66WIwcOcNU0zG8X1aSQgXu2SBjOWpUoiQDcm%2FXYkCW4Zphemx3JShOrMgV7rHDcrOWiBlGaVmxXyAKjbW832S2mnRAsW6gkOgyZ5FfSZknBoMRt44mko33ndhKdqsYqWw%2BOuQ5NRJpjS8z1%2BMYTEteVfBv6Uppxa0OhMpZwpk3bsBZG3X9UoXgalib9R49GOQDo6%2BaZBg%3D&X-Amz-SignedHeaders=host&X-Amz-Signature=b04bb3a6ae0d458eaa3dcc1a8a697559ec7c7d104dff7698671780bbec9b2e5c',
		filename: 'Pic1.png',
		contentType: 'image/png',
		updatedAt: new Date(),
	},
	{
		id: '43908cba-1a35-4221-8025-ecc4c3bcdddd',
		fileUrl:
			'https://mlg-nonprod-stg-ghr-backend-qa.s3.us-west-2.amazonaws.com/6qyy4ct5ndg79rrg0ou8imeeuz8c?response-content-disposition=inline%3B%20filename%3D%22Pic2.png%22%3B%20filename%2A%3DUTF-8%27%27Pic2.png&response-content-type=image%2Fpng&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAZVSMF5PD6JKNPJ4O%2F20240627%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240627T095004Z&X-Amz-Expires=300&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIBm5BUf1UmPBipNrVj17j6NpIjV7QdexLV6NU8vahq2%2BAiAA05PQMZoIxWjo5CrqLY67kgo3e%2Fij4qlhZnEZ0uyM2SqlBQjr%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAMaDDY2NDgwNTk2MDY0NyIMKV%2FbTx7YtIUVLgpuKvkEjTYSKxOjWBBOjNtK%2F5BcjqnfjEhg2wiRRFpaJzvyyN%2F%2FjFd054HzZHTVhyt7FWGng867uR5R0P68d43RJdzWp5VUzfeCAvAIQxExqpjWo1330H13MCG1sjPIuNgTCBQVgrvhbl1o60o1cq%2FqiVrGtEFv3%2BBz3EgFdi93YG4EeuyviQFerHlwGZ5lfwWCyRGo%2FftTOSiAhN67BXfFd9fAo%2FDwTcoyuM3BDOTgVF3rA1VWI21%2BgJsz408xCEEkDJELfyqJZLntpuZPhFI%2Fh2qQNu8wMsTRW4hmoIoxrb3C9OsOQVG3ddwo4bZjL%2F8tlWhn3JgpTvsSHDwuTwIqESdtNI4IhRXXTorYItMTpyMRmOgjtWb2butRb909XmVIyckfM5liWwoG38c86aSXzzi4pmILUueTuVGK273rwrBQmRXLz9uvVvPv4IYvJxx2WC5nmqTXlUaM39H41owXyItNKTFnPMmTH8FF3CtgMoQxoey8dsO%2B34x1PpfKrrE8YNwwDO8NrOqNVvNAWqM2Eg%2BL37CPPEqyQmslWP7vSBZBgnLr5m%2BpPxiZdlpQUGc%2BWTS2fa8kVNjJNdahJuDsZCs5efOWW2BeVBoMi%2FaCblzeh3gZoRzU9%2B2MtYeWyGa2SB4UGaTRAdzE7ddEw2lf9otil%2FmRNC4woUPwvn7%2BkNCzpb3fMt3v4O7VefcUf2zKri8dsaoowNBqRm1xQAyewj%2Ba%2BL9xI3poR3oQkGZ1rHsCXOVuhMHIsS9oK7b7%2B1P1C2bzf2Adri2FehZ1EVCMsDruX4SqtVfiUe0XIFCgC%2Bn2oLfnFJBageh0YEH%2BxGegnzKCx51a%2FmFSXORSMPvq9LMGOpsB7I%2Frcr66WIwcOcNU0zG8X1aSQgXu2SBjOWpUoiQDcm%2FXYkCW4Zphemx3JShOrMgV7rHDcrOWiBlGaVmxXyAKjbW832S2mnRAsW6gkOgyZ5FfSZknBoMRt44mko33ndhKdqsYqWw%2BOuQ5NRJpjS8z1%2BMYTEteVfBv6Uppxa0OhMpZwpk3bsBZG3X9UoXgalib9R49GOQDo6%2BaZBg%3D&X-Amz-SignedHeaders=host&X-Amz-Signature=07cd4d60c43d14f9ee10728952dbbf92df074f41a728a2942dde4137c54009fb',
		filename: 'Pic2.png',
		contentType: 'image/png',
		updatedAt: new Date(),
	},
	{
		id: '4326382a-9893-4d0f-aac3-6996b679a872',
		fileUrl:
			'https://mlg-nonprod-stg-ghr-backend-qa.s3.us-west-2.amazonaws.com/589g6mnz4u9c7lj0oevn84pvf2sn?response-content-disposition=inline%3B%20filename%3D%22Pic3.png%22%3B%20filename%2A%3DUTF-8%27%27Pic3.png&response-content-type=image%2Fpng&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAZVSMF5PD6JKNPJ4O%2F20240627%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240627T095004Z&X-Amz-Expires=300&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEIaCXVzLXdlc3QtMiJGMEQCIBm5BUf1UmPBipNrVj17j6NpIjV7QdexLV6NU8vahq2%2BAiAA05PQMZoIxWjo5CrqLY67kgo3e%2Fij4qlhZnEZ0uyM2SqlBQjr%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAMaDDY2NDgwNTk2MDY0NyIMKV%2FbTx7YtIUVLgpuKvkEjTYSKxOjWBBOjNtK%2F5BcjqnfjEhg2wiRRFpaJzvyyN%2F%2FjFd054HzZHTVhyt7FWGng867uR5R0P68d43RJdzWp5VUzfeCAvAIQxExqpjWo1330H13MCG1sjPIuNgTCBQVgrvhbl1o60o1cq%2FqiVrGtEFv3%2BBz3EgFdi93YG4EeuyviQFerHlwGZ5lfwWCyRGo%2FftTOSiAhN67BXfFd9fAo%2FDwTcoyuM3BDOTgVF3rA1VWI21%2BgJsz408xCEEkDJELfyqJZLntpuZPhFI%2Fh2qQNu8wMsTRW4hmoIoxrb3C9OsOQVG3ddwo4bZjL%2F8tlWhn3JgpTvsSHDwuTwIqESdtNI4IhRXXTorYItMTpyMRmOgjtWb2butRb909XmVIyckfM5liWwoG38c86aSXzzi4pmILUueTuVGK273rwrBQmRXLz9uvVvPv4IYvJxx2WC5nmqTXlUaM39H41owXyItNKTFnPMmTH8FF3CtgMoQxoey8dsO%2B34x1PpfKrrE8YNwwDO8NrOqNVvNAWqM2Eg%2BL37CPPEqyQmslWP7vSBZBgnLr5m%2BpPxiZdlpQUGc%2BWTS2fa8kVNjJNdahJuDsZCs5efOWW2BeVBoMi%2FaCblzeh3gZoRzU9%2B2MtYeWyGa2SB4UGaTRAdzE7ddEw2lf9otil%2FmRNC4woUPwvn7%2BkNCzpb3fMt3v4O7VefcUf2zKri8dsaoowNBqRm1xQAyewj%2Ba%2BL9xI3poR3oQkGZ1rHsCXOVuhMHIsS9oK7b7%2B1P1C2bzf2Adri2FehZ1EVCMsDruX4SqtVfiUe0XIFCgC%2Bn2oLfnFJBageh0YEH%2BxGegnzKCx51a%2FmFSXORSMPvq9LMGOpsB7I%2Frcr66WIwcOcNU0zG8X1aSQgXu2SBjOWpUoiQDcm%2FXYkCW4Zphemx3JShOrMgV7rHDcrOWiBlGaVmxXyAKjbW832S2mnRAsW6gkOgyZ5FfSZknBoMRt44mko33ndhKdqsYqWw%2BOuQ5NRJpjS8z1%2BMYTEteVfBv6Uppxa0OhMpZwpk3bsBZG3X9UoXgalib9R49GOQDo6%2BaZBg%3D&X-Amz-SignedHeaders=host&X-Amz-Signature=75a9e6fd0e48e4d7ac0e98392d05786f291629b9dd3e3a36f4304dcd3d084a5b',
		filename: 'Pic3.png',
		contentType: 'image/png',
		updatedAt: new Date(),
	},
]
